import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Layout from '@/components/Layout';
import ProductCard from '@/components/ProductCard';
import SEO from '@/components/SEO';
import axios from 'axios';
import { ChevronRight } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const RiflajePage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}/api/products?category=riflaje&active_only=true`);
      setProducts(response.data);
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <SEO
        title="Riflaje Decorative"
        description="Riflaje decorative pentru interior. Panouri riflate moderne pentru living, dormitor și spații comerciale. Shagun Surfaces Brașov."
        canonicalUrl="https://shagunsurfaces.ro/riflaje"
      />
      <section className="relative pt-32 pb-20 bg-[#050505]" data-testid="riflaje-hero">
        <div className="max-w-7xl mx-auto px-6">
          <nav className="flex items-center gap-2 text-sm mb-8">
            <Link to="/" className="text-[#A3A3A3] hover:text-[#D4AF37]">Acasă</Link>
            <ChevronRight size={14} className="text-[#A3A3A3]" />
            <span className="text-[#D4AF37]">Riflaje</span>
          </nav>

          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-white mb-6">
            Riflaje
          </h1>
          <p className="text-[#A3A3A3] text-lg max-w-2xl">
            Riflaje decorative pentru interioare moderne. Panouri riflate din diverse materiale pentru un design elegant și contemporan.
          </p>
        </div>
      </section>

      <section className="py-12 bg-[#0a0a0a]" data-testid="riflaje-products">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="font-serif text-2xl text-white mb-8">Produse</h2>

          {loading ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {[...Array(6)].map((_, i) => (
                <div key={i} className="bg-[#121212] aspect-square animate-pulse" />
              ))}
            </div>
          ) : products.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {products.map((product, index) => (
                <ProductCard key={product.id} product={product} index={index} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <p className="text-[#A3A3A3] text-lg mb-4">
                Momentan nu avem produse în această categorie.
              </p>
              <p className="text-[#A3A3A3] text-sm">
                Revenți în curând sau contactați-ne pentru mai multe detalii.
              </p>
            </div>
          )}
        </div>
      </section>
    </Layout>
  );
};

export default RiflajePage;
